import { z } from "zod";

/**
 * Integration key enum
 */
export enum IntegrationKey {
  Famous = "famous",
  Plaid = "plaid",
  Payments = "payments",
}

/**
 * Base schema shared by all integrations
 */
export const IntegrationBaseSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  name: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const IntegrationAvailabilitySchema = z.object({
  available: z.boolean(),
  reason: z.string().optional(),
});

export type IntegrationAvailability = z.infer<
  typeof IntegrationAvailabilitySchema
>;
